import { cva } from 'class-variance-authority';

export const avatarVariants = cva(
  // Base styles
  [
    'relative',
    'inline-flex',
    'items-center',
    'justify-center',
    'overflow-hidden',
    'bg-gray-200',
    'dark:bg-slate-700',
    'text-gray-600',
    'dark:text-slate-300',
    'font-medium',
    'select-none',
    'flex-shrink-0',
  ],
  {
    variants: {
      size: {
        xs: ['w-6', 'h-6', 'text-xs'],
        sm: ['w-8', 'h-8', 'text-sm'],
        md: ['w-10', 'h-10', 'text-base'],
        lg: ['w-12', 'h-12', 'text-lg'],
        xl: ['w-16', 'h-16', 'text-xl'],
        '2xl': ['w-24', 'h-24', 'text-2xl'],
      },
      shape: {
        circle: ['rounded-full'],
        square: ['rounded-lg'],
      },
    },
    defaultVariants: {
      size: 'md',
      shape: 'circle',
    },
  }
);

export const avatarImageStyles = 'w-full h-full object-cover';

export const avatarInitialsStyles = 'uppercase';

export const statusIndicatorVariants = cva(
  // Base styles for status indicator
  ['absolute', 'rounded-full', 'border-2', 'border-white', 'dark:border-slate-800'],
  {
    variants: {
      size: {
        xs: ['w-1.5', 'h-1.5', 'bottom-0', 'right-0'],
        sm: ['w-2', 'h-2', 'bottom-0', 'right-0'],
        md: ['w-2.5', 'h-2.5', 'bottom-0', 'right-0'],
        lg: ['w-3', 'h-3', 'bottom-0.5', 'right-0.5'],
        xl: ['w-4', 'h-4', 'bottom-0.5', 'right-0.5'],
        '2xl': ['w-5', 'h-5', 'bottom-1', 'right-1'],
      },
      status: {
        online: ['bg-success-500'],
        offline: ['bg-gray-400'],
        away: ['bg-warning-500'],
        busy: ['bg-error-500'],
      },
    },
    defaultVariants: {
      size: 'md',
      status: 'offline',
    },
  }
);

export const ringVariants = {
  primary: 'ring-2 ring-offset-2 ring-primary-600 dark:ring-offset-slate-900',
  secondary: 'ring-2 ring-offset-2 ring-secondary-600 dark:ring-offset-slate-900',
  gray: 'ring-2 ring-offset-2 ring-gray-400 dark:ring-offset-slate-900',
};
